import classNames from "../../../utils/classNames"

export const NumberInput = ({ label, register, registerName, min = null, max = null, step = ".01", classes = "", disabled = false }) => {

  return (
    <div className={classNames(classes, "sm:col-span-1")}>
      <label className="text-sm font-medium text-gray-700">{label}</label>
      <input
        {...register(registerName)}
        type="number"
        step={step}
        disabled={disabled}
        min={min ? min : ""}
        max={max ? max : ""}
        className={classNames(disabled ? "bg-gray-300" : "", "w-full block mt-1 shadow-sm focus:ring-etpink-500 focus:border-etpink-500 sm:text-sm border-gray-300 rounded-md")}
      />
    </div>
  )
}